<template>
  <div :style="{ width: width, 'max-width': maxWidth }">
    <!-- Label -->
    <slot name="label" v-if="$slots.label" />
    <div class="q-mb-sm" v-if="label && !$slots.label">
      {{ label }}
      <span class="text-negative" v-if="required">*</span>
    </div>

    <!-- Description -->
    <slot name="description" v-if="$slots.description" />
    <div class="text-secondary q-mb-xs text-caption" v-if="description">
      {{ description }}
    </div>

    <ButtonDropdown v-model="visible" color="input" :label="dateText" outline :size="size">
      <q-date
        v-model="selectedDate"
        :emit-immediately="emitImmediately"
        :default-view="defaultView"
        :mask="format"
      />
    </ButtonDropdown>
  </div>
</template>

<script>
import moment from 'moment';
import ButtonDropdown from './ButtonDropdown';

export default {
  name: 'DatePicker',
  components: { ButtonDropdown },
  props: {
    size: {
      type: String,
      default: 'md',
    },
    value: {
      type: [Date, String],
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    width: {
      type: String,
      default: '100%',
    },
    maxWidth: {
      type: String,
    },
    label: {
      type: String,
      default: '',
    },
    description: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    emitImmediately: {
      type: Boolean,
      default: false,
    },
    defaultView: {
      type: String,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    dateText() {
      return `${this.convertDate(this.value)}`;
    },
    selectedDate: {
      set(value) {
        this.$emit('input', value);
        this.visible = false;
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    convertDate(date) {
      return moment(date).format(this.format);
    },
  },
};
</script>

<style lang="scss" scoped></style>
